import * as React from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import type { Option } from 'modules/core/components/Popover/Content'
import PopoverContent from 'modules/core/components/Popover/Content'
import UserAvatar from 'modules/core/components/UserAvatar'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'
import type User from 'modules/core/store/models/User'

import EditUserModal from 'modules/permissions/components/EditUserModal'
import type PermissionGroup from 'modules/permissions/store/models/PermissionGroup'

import styles from './index.module.scss'

interface Props {
  permissionGroup: PermissionGroup
  user: User
}

const Item = ({ permissionGroup, user }: Props) => {
  const { navigation } = useNavigation()

  const [editModalOpen, setEditModalOpen] = React.useState(false)
  const [open, toggle] = useToggle(false)

  const options = () => {
    const allowedOptions: Option[] = []

    if (users.current.policy.can('permissions.groupAssignEmployees')) {
      allowedOptions.push({
        to: navigation.settings.permissions.id.externals.userIdAssign.fullPath({
          id: permissionGroup.id,
          userId: user.id,
        }),
        title: i18n.t('settings.permissions.group.change_group'),
      })
    }

    if (users.current.policy.can('permissions.editExternalUsers')) {
      allowedOptions.push({
        title: i18n.t('settings.permissions.users.edit'),
        onClick: () => {
          setEditModalOpen(true)
        },
      })
    }

    return allowedOptions
  }

  return (
    <div className={styles.root}>
      <div className={styles.profile}>
        <div className={styles.avatar}>
          <UserAvatar user={user} />
        </div>
        <div>
          <div className={styles.name}>
            <div className={styles.title}>{user.fullName()}</div>
          </div>
          <div className={styles.jobTitle}>
            <div className={styles.title}>{i18n.t('common.roles.external')}</div>
          </div>
        </div>
      </div>
      {options().length > 0 && (
        <div className={styles.options}>
          <Popover
            attachment="top right"
            targetAttachment="bottom center"
            toggle={toggle}
            open={open}
          >
            <Button type="secondary" onClick={toggle(true)} iconName="ellipsis" />
            <PopoverContent onClose={toggle(false)} options={options()} />
          </Popover>
        </div>
      )}
      {editModalOpen && (
        <EditUserModal
          onClose={() => setEditModalOpen(false)}
          permissionGroup={permissionGroup}
          user={user}
        />
      )}
    </div>
  )
}

export default observer(Item)
